import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlistados-extraescolares',
  templateUrl: './adminlistados-extraescolares.component.html',
  styleUrls: ['./adminlistados-extraescolares.component.scss']
})
export class AdminlistadosExtraescolaresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminlistados-extraescolares/adminlistados-extraescolares.component.ts